export const categories = [
  { id: 'all', name: '全部', slug: 'all' },
  { id: 'hot', name: '热门推荐', slug: 'hot' },
  { id: 'romance', name: '恋爱', slug: 'romance' },
  { id: 'fantasy', name: '奇幻', slug: 'fantasy' },
  { id: 'action', name: '动作', slug: 'action' },
  { id: 'suspense', name: '悬疑', slug: 'suspense' },
  { id: 'comedy', name: '搞笑', slug: 'comedy' },
  { id: 'historical', name: '古风', slug: 'historical' },
  { id: 'urban', name: '都市', slug: 'urban' },
  { id: 'drama', name: '剧情', slug: 'drama' },
];

export const categoryMap: Record<string, string> = {
  all: '全部',
  hot: '热门推荐',
  romance: '恋爱',
  fantasy: '奇幻',
  action: '动作',
  suspense: '悬疑',
  comedy: '搞笑',
  historical: '古风',
  urban: '都市',
  drama: '剧情',
};